export default function ArrowDownIconDark( {classStyle}:{classStyle : string}) {
    return (
        <svg className={classStyle} width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.53366 6.64356L0.193175 1.82364C-0.0643917 1.59118 -0.0643917 1.2143 0.193175 0.981865L0.816057 0.419701C1.07318 0.187638 1.48991 0.187191 1.74764 0.418708L6.00001 4.23858L10.2524 0.418708C10.5101 0.187191 10.9268 0.187638 11.1839 0.419701L11.8068 0.981865C12.0644 1.21432 12.0644 1.5912 11.8068 1.82364L6.46637 6.64356C6.2088 6.876 5.79122 6.876 5.53366 6.64356Z" fill="#233638"/>
</svg>

    )
}